import { css } from "styled-components";

export const maxWidth = css`
    max-width: 1400px;
`;

export const paddingLeftAndRight = css`
    padding: 0 2rem 0 2rem;
`

export const displayFlexWidthHeight = css`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

export const hoverButton = css`
      border-color: ${props=> props.theme.colors.tertiary};
      color: ${props=> props.theme.colors.tertiary};
` 

export const cursorPointer = css`
    @media screen and (min-width: 1000px) {
        cursor: pointer;
    }
`
